/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import moment from 'moment-timezone';

export default {
  timezone: "America/New_York",

  analyst_role_name: "USER",
  excludeUserList: ["olivier.mercier@wysdom.ai"],

  _amplitudeLog(name, eventProps) {
    // console.log('_amplitudeLog>>>', name, eventProps)
    // eslint-disable-next-line no-undef
    if(amplitude) {
      // eslint-disable-next-line no-undef
      amplitude.getInstance().logEvent(name, eventProps);
    }
  },

  _updateUser(authUser) {
    //console.log('_updateUser>>>', authUser)
    // eslint-disable-next-line no-undef
    if(amplitude) {
      let loginDate = moment.tz(authUser.loginDate, this.timezone).format("YYYY-MM-DDTHH:mm:ss");

      const userEmail = authUser.user.email || "";
      const isExcludeUserFromReporting = this.excludeUserList.includes(userEmail.toLowerCase());
      
      // eslint-disable-next-line no-undef
      var identify = new amplitude.Identify()
        .set('session_id', authUser.uuid)
        .set('user_name', authUser.user.name)
        .set('user_email', authUser.user.email)
        .set('login_time', loginDate)
        .set('exclude_user_from_reporting', isExcludeUserFromReporting)
        .set('company', (authUser.company ? authUser.company.name : 'NA'));

      // eslint-disable-next-line no-undef
      amplitude.getInstance().setUserId(`${authUser.company.companyCode}_${authUser.user.email}`);
      // eslint-disable-next-line no-undef
      amplitude.getInstance().identify(identify);
    }
  },

  _getRoleName(role) {
    if (role == this.analyst_role_name) {
      return 'ANALYST'
    } else {
      return role
    }
  },

  reset() {
    // eslint-disable-next-line no-undef
    if(amplitude) {
      // eslint-disable-next-line no-undef
      amplitude.getInstance().setUserId(null);
    }
  },

  eventLog(name, authUser, data) {
    const isC1Auth = ((authUser || {}).user || {}).c1Permissions ? true : false;

    //eslint-disable-next-line no-undef
    if(!isC1Auth && amplitude && amplitude.getInstance().options && amplitude.getInstance().options.apiKey && authUser) {
      if(authUser.amplitudeDebug) {
        console.log("amplitude_eventLog", name, data);
      }
      
      if (authUser && authUser.user && authUser.user.role) {
        data = {
          ...data,
          role: this._getRoleName(authUser.user.role),
        }
      }

      if(name == 'login_page_loaded') {
        this.reset();
        this._amplitudeLog(name, (data ? data : {}));
      }
      else if(name == 'customer_login') {
        this._updateUser(authUser);
        this._amplitudeLog(name, (data ? data : {}));
      }
      else if(name == 'switch_company') {
        this._amplitudeLog(name, (data ? data : {}));
      }
      else if(name == 'update_user') {
        this._updateUser(authUser);
      }
      else if(name == 'logged_out' && authUser.loginDate && authUser.loginDate.getTime) {
        let sessionLength = ((new Date()).getTime() - authUser.loginDate.getTime()) / 1000;
        this._amplitudeLog(name, {
          session_length: sessionLength,
          logout_method: data.logout_method,
          ...data
        });
        this.reset();
      }
      else {
        this._amplitudeLog(name, (data ? data : {}));
      }
    }
  }
}